import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import { useState } from "react";
import { ICommonServiceProps } from "@api/types/globalService.types";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";
import { urlUtility } from "@repo/utilities/url.utility.ts";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import URLS from "@api/constants/urls";

type TClaimTemplateFieldsServiceProps = Omit<
  ICommonServiceProps,
  "cacheKeys" | "filters"
>;
export const useGetAllClaimTemplateFieldsService = ({
  page = "1",
  per_page = "15",
  enableQuery = true,
}: TClaimTemplateFieldsServiceProps) => {
  const [searchClaimTemplateFields, setSearchClaimTemplateFields] =
    useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(
    searchClaimTemplateFields
  );
  const urlQueries = urlUtility.getUrlQueries(location.search);
  const claimTemplateId = +urlQueries["claim-template-id"] || "";
  const claimTypeId = urlQueries?.["claim-type-id"] || "";

  const allClaimTemplateFields = useQuery({
    queryKey: [
      ...CACHE_KEYS.CLAIM_TEMPLATES,
      claimTemplateId,
      page,
      per_page,
      debouncedQuery,
    ],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: `${URLS.CLAIM_TEMPLATE_FIELDS}/${claimTemplateId}}`,
        searchParams: {
          page,
          per_page,
          claim_type_id: claimTypeId,
        },
      }),
    enabled: enableQuery && !!claimTemplateId,
  });

  const allMissingClaimTemplateFields = useQuery({
    queryKey: [
      ...CACHE_KEYS.CLAIM_TEMPLATE,
      claimTemplateId,
      page,
      per_page,
      debouncedQuery,
    ],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: `${URLS.CLAIM_TEMPLATE}/${claimTemplateId}/${URLS.MISSING_FIELDS}`,
      }),
    enabled: enableQuery && !!claimTemplateId,
  });
  return {
    service: { allClaimTemplateFields, allMissingClaimTemplateFields },
    state: { searchClaimTemplateFields, setSearchClaimTemplateFields },
  };
};
